// services/school-ui/src/pages/chat/attachments/AttachmentStrip.tsx
//
// Teacher toolkit wrapper around the library's composer attachment
// primitives. Renders a paperclip button + horizontal chip row above
// the composer input.
//
//   • This whole strip is only mounted when the attachment adapter is
//     registered — the parent (AssistantUiThread) guards it with
//     {attachments && <AttachmentStrip />}. Do NOT rely on
//     ComposerPrimitive.AddAttachment self-hiding when no adapter is
//     present: it does not reliably do so, and an always-mounted
//     paperclip threw "Attachments are not supported" during the
//     capabilities-fetch window (nova-os-school#35).
//   • ComposerPrimitive.Attachments iterates over the composer's
//     current attachment list; for each entry we render
//     TeacherAttachmentChip via the per-attachment slot.

import { useTranslation } from "react-i18next";
import { ComposerPrimitive } from "@assistant-ui/react";
import { TeacherAttachmentChip } from "./TeacherAttachmentChip";

/** chips 行 —— 输入框上方独立一行(Claude/ChatGPT 式),空时 :empty 隐藏,
 *  不再和输入框抢横向空间(Jarod 2026-08-26)。 */
export function AttachmentChipsRow(): JSX.Element {
  return (
    <div className="teacher-attachments-strip">
      <ComposerPrimitive.Attachments
        components={{ Attachment: TeacherAttachmentChip }}
      />
    </div>
  );
}

/** 回形针 —— 移到输入行左端(与 Claude 一致)。 */
export function AttachmentAddButton(): JSX.Element {
  const { t } = useTranslation();

  return (
    <ComposerPrimitive.AddAttachment
        multiple
        aria-label={t("chat.attachments.addButton")}
        className="teacher-attachments-paperclip"
        title={t("chat.attachments.addButtonHint")}
      >
        <svg
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <path d="M11.5 6L7 10.5a2 2 0 01-2.83-2.83l5.5-5.5a3 3 0 014.24 4.24l-6.5 6.5a4 4 0 11-5.66-5.66" />
        </svg>
      </ComposerPrimitive.AddAttachment>
  );
}
